// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18431": "b80904821cf5","38927": "8f297ccad00b","39424": "663922e2c223","574": "e3dfe3a57a46","5856": "0308423753f6","66863": "c939bdd77392",}[chunkId] + ".css"
}